"use client"

import { useEffect, useState } from "react"
import dynamic from "next/dynamic"
import { UserIcon } from "lucide-react"

import { useAuthStore } from "@/lib/store/auth-store"
import { useAuthDialog } from "@/features/auth"
import { Button } from "@/components/ui/button"

// import { initiateSSO } from "@/app/actions/auth"

const UserMenu = dynamic(
  () => import("./user-menu").then((mod) => mod.UserMenu),
  {
    ssr: false,
  }
)

export function LoginButton() {
  const [isClient, setIsClient] = useState(false)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const openDialog = useAuthDialog((state) => state.openDialog)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // During SSR, don't show any authentication state
  if (!isClient) {
    return (
      <Button variant="be" className="h-9 rounded-full shadow-none">
        <UserIcon className="h-4 w-4" />
        <span className="hidden lg:inline ml-2">Đăng nhập/Đăng ký</span>
      </Button>
    )
  }

  if (isAuthenticated) {
    return <UserMenu />
  }

  return (
    <Button
      variant="be"
      className="h-9 rounded-full shadow-none"
      onClick={() => {
        openDialog()
      }}
    >
      <UserIcon className="h-4 w-4" />
      <span className="hidden lg:inline ml-2">Đăng nhập/Đăng ký</span>
    </Button>
  )
}
